import { defineStore } from 'pinia';
import { ref } from 'vue';

const PAGE_SIZES = [10, 20, 30, 40, 50] as const;
// Will be use for paginating in boost pages
const PAYMENT_PLANS_PAGE_SIZES = [6, 10, 20, 30, 40] as const;

const notInIframe = window.self === window.top;

export const useGeneralStore = defineStore('generalStore', {
  state: () => {
    const passwordReset = ref(false); // Will be used in otp screen for redirect
    const passwordResetFallbackToWhatsApp = ref(false);
    const iFrame = ref(!notInIframe);
    const isMenuOpen = ref(false);
    const pageSize = ref(10);
    const paymentPlanPageSize = ref(6);

    return {
      passwordReset,
      passwordResetFallbackToWhatsApp,
      iFrame,
      isMenuOpen,
      pageSize,
      paymentPlanPageSize,
    };
  },
  persist: notInIframe,
  actions: {
    reset() {
      this.$reset();
    },
    getPageSizeOptions(): readonly number[] {
      return PAGE_SIZES;
    },
    getPaymentPlanPageSizeOptions(): readonly number[] {
      return PAYMENT_PLANS_PAGE_SIZES;
    },
  },
});
